import tools from './assets/js/tools-qureka';
import config from './assets/js/config-faq';
import FontResize from './assets/js/font-resize';
import Toast from './assets/js/toast-time';

// debug code
if(process.env.NODE_ENV === 'development'){
    require ('./mockjs');
}

var languages = {}

var toast = new Toast();

var __DEFS__ = {
    downloadFiles: [
        ''
    ],
    supportMethod: {},
    appName: '',
    pkgName: '',
    activityName: '',
    appStatus: 'download',      // download: 未下载, downloaded: 已下载 , installed: 已安装
    regsitHandler: null,
    
    CLIENT_WIDTH: document.documentElement.clientWidth,

    lang: config.defaultLang,
    allLangs: [
        "bn",
        "en",
        "gu",
        "hi",
        "kn",
        "ml",
        "mr",
        "pa",
        "ta",
        "te",
        "ur",
        "fr",
        "es"
    ],
    el: null,
    urlOpts: {},
    page: ''
};

var __PROPERTYPE__ = {
    $el: __DEFS__.el,
    $mainEl: document.getElementById('main'),
    $downloadCnt: document.getElementById('download_container'),
    $downloadClose: document.getElementById('download_close'),
    $downloadTxt: document.getElementById('download-txt'),
    $abtn: document.getElementById('download-apk'),

    setDirection: function(){
        var self = this;
        __DEFS__.urlOpts = tools.getUrlString(location.search);

        if(__DEFS__.urlOpts['c']){
            __DEFS__.lang = __DEFS__.urlOpts['c'];
        }else{
            __DEFS__.lang = tools.getLocaleLang(__DEFS__.allLangs);
        }

        var setRight = function(){
            self.$mainEl.className = 'main direction-rtl';
        }

        var setLeft = function(){
            self.$mainEl.className = 'main direction-ltr';
        }
        switch(__DEFS__.lang){
            case 'ur': 
                setRight();
                break;
            default: 
                setLeft();
                break;
        }
    },

    removeEvt: function(){
        this.$abtn.removeEventListener('click', this.handlerBtn, false);
    },

    // 初始化页面
    initPage: function(){
        var self = this;
        
        self.setDirection();
        self.setBtnStatus();
        self.bindEvt();
    },

    setBtnStatus: function(){
        var self = this;

        self.$downloadCnt.className = 'download_container active';

        function setTxt(str){
            if(self.$downloadTxt.tagName.toLowerCase() === 'img'){
                self.$downloadTxt.src = str;
            }else{
                self.$downloadTxt.innerHTML = str;
            }
        }

        // 已下载, 未安装
        if(__DEFS__.urlOpts['exista'] && __DEFS__.urlOpts['exista'] != ''){
            setTxt(languages.en.install);
        }else{
            setTxt(languages.en.download);
        }
    },

    handlerBtn: function(evt){
        evt.stopPropagation();
        
        __PROPERTYPE__.$abtn.className = 'download active';

        if(__DEFS__.urlOpts['exista'] && __DEFS__.urlOpts['exista'] != ''){
            $as.send('click-install-' + __DEFS__.appName);

        }else{
            toast.show();

            if(toast.isShow){
                return;
            }
            if(__DEFS__.supportMethod['processDownload']){
                $as.send('click-download-' + __DEFS__.appName);
            }
        }
    },

    bindEvt: function(){
        var self = this;

        tools.addEvt(self.$abtn, 'click', self.handlerBtn);
        tools.addEvt(self.$downloadClose, 'click', function(e){
            e.stopPropagation();

            self.$downloadCnt.className = "download_container";
            $as.send('click-close-' + __DEFS__.appName);
        });
        tools.addEvt(self.$mainEl, 'click', function(e){
            e.stopPropagation();

            $as.send('click-main-' + __DEFS__.appName);
            if(self.$downloadCnt.className.indexOf('active') < 0) {
                self.$downloadCnt.className = "download_container active";
            }
        });
    },

    init: function(opts){
        this.$el = document.querySelector(opts.el);
        this.$abtn.setAttribute('href', __DEFS__.downloadFiles[0]);

        if(!this.$el)
            throw new Error('No context!');


        this.initPage();

        var options = {
            el: document.querySelector('html'),
            max: 1080,
            min: 320,
            maxFont: 30,
            minFont: 14
        };
        new FontResize(options);
    },

    // 清除 Toast
    clearToast: function(){
        toast.clear();
    }
};

var DynamicIcon = function(opts){
    __DEFS__.appName = opts.appName;
    __DEFS__.pkgName = opts.pkgName;
    __DEFS__.downloadFiles[0] = opts.downloadLink;
    languages = opts.lang;
    this.init(opts);
};

DynamicIcon.prototype = __PROPERTYPE__;

export default DynamicIcon;


// WEBPACK FOOTER //
// ./src/DynamicIcon-self-analytics.js